import ApiService from '@/services/api.service.js';

export const AdminUserService = {

  verifyUserEmail: function (id) {
    return ApiService.get('/user/verify-email/' + id);
  }

}

export default {AdminUserService}